export default class DropPointParseException extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'DropPointParseException';
    }
}